import { isRejected, Middleware } from "@reduxjs/toolkit"
import * as Sentry from "@sentry/react"

export const sentryRejectionMiddleware: Middleware = () => next => action => {
    if (
        isRejected(action) &&
        !action.meta.rejectedWithValue && // handled API Errors
        !action.meta.condition &&
        !action.meta.aborted &&
        action.error.name !== "AxiosError" // HTTP failures are handled by the httpClientIntegration
    ) {
        const error = new Error(action.error.message || action.type)
        error.name = action.error.name || "Error"
        if (action.error.stack) error.stack = action.error.stack
        Sentry.captureException(error, {
            tags: {
                redux_action: action.type,
                endpoint: (action.meta.arg as any)?.endpointName,
            },
        })
    }
    return next(action)
}
